// frontend/src/types/settings.types.ts

export interface ProfileUpdateInput {
  full_name: string;
  age: number | null;
  school_name?: string | null;
  interests: string[];
}

export const AVATAR_OPTIONS = [
  { value: 'robot', icon: '🤖', name: 'Robot' },
  { value: 'wizard', icon: '🧙', name: 'Büyücü' },
  { value: 'gamer', icon: '🎮', name: 'Gamer' },
  { value: 'astronaut', icon: '🚀', name: 'Astronot' },
] as const;
